import { Pipe, PipeTransform } from '@angular/core';
import { TaskV2 } from '../types';

const boxPickup = '/assets/images/box-pickup.svg';
const pickup = '/assets/images/origin.svg';
const dropoff = '/assets/images/destination.svg';

@Pipe({
  name: 'taskTypeImage',
})
export class TaskTypeImagePipe implements PipeTransform {
  public transform(value: TaskV2[]): string {
    if (value.find((value1) => value1.action === 'dropoff' || value1.action === 'backhaul_dropoff')) {
      return dropoff;
    }
    if (value.find((value1) => value1.action === 'pickup' || value1.action === 'backhaul_pickup')) {
      return pickup;
    }
    if (value.find((value1) => value1.action === 'boxPickup')) {
      return boxPickup;
    }
    return '';
  }
}
